import styles from './SvgContainer2.module.css';

const SvgContainer2 = () => {
  return (
    <div className={styles.svgContainer}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="2812"
        height="1236"
        viewBox="0 -60 1512 1036"
        fill="none"
        className={styles.top}
      >
        <path
          d="M1616.45 864.408C1722.01 930.785 1706.77 1006.22 1685.95 1035.64L1530.59 985.615L-144.969 567.715L-228.28 68.9389C-211.658 37.4017 -148.962 -14.0657 -31.1511 32.3609C116.112 90.3942 139.139 44.8489 182.216 20.3189C225.293 -4.2111 280.947 -22.3897 383.2 66.0039C485.454 154.398 596.678 222.818 726.815 201.415C830.924 184.292 903.778 213.189 929.205 226.029C954.631 238.87 1020.08 279.819 1058.85 369.095C1107.31 480.689 1230.02 530.407 1366.73 562.692C1503.44 594.977 1515.7 647.454 1515.39 693.579C1515.07 739.704 1484.5 781.438 1616.45 864.408Z"
          fill="#1D1534"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1812"
        height="1036"
        viewBox="0 200 1512 836"
        fill="none"
        className={styles.bottom}
      >
        <path
          d="M-293.008 496.136C-407.462 470.612 -423.6 405.011 -417.362 375.4L-366.464 0.914407L1618.03 270.635L1567.13 645.121C1565.24 675.322 1532.18 734.237 1415.07 728.287C1268.67 720.851 1266.77 764.202 1239.89 795.853C1213.01 827.504 1173.1 857.383 1052.97 813.02C932.842 768.658 812.829 743.002 711.386 795.668C630.231 837.802 557.736 833.971 531.376 830.388C505.016 826.806 434.128 811.149 367.163 748.884C283.456 671.052 160.949 663.747 33.3396 674.439C-94.2698 685.13 -124.763 645.682 -142.218 608.006C-159.672 570.329 -149.941 528.041 -293.008 496.136Z"
          fill="#1D1534"
        />
      </svg>
    </div>
  )
};

export default SvgContainer2;